import { z } from 'zod';

export const pickupPointCreateSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(150),
  address: z.string().min(1, 'Morada obrigatória').max(2000),
  daysToCollect: z.number().int().min(1).max(60).default(3),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().default(0),
});

export const pickupPointUpdateSchema = pickupPointCreateSchema.partial();

export type PickupPointCreateInput = z.infer<typeof pickupPointCreateSchema>;
export type PickupPointUpdateInput = z.infer<typeof pickupPointUpdateSchema>;
